<form [formGroup]="ballotForm">
  <div id="cib-finalise-ballot-modal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div id="cib-modal-content" class="relative p-6 bg-white rounded-lg shadow-lg w-[750px] h-[260px]">

      <button id="cib-modal-close-button" class="absolute right-4 top-4 p-2" (click)="cancel()">
        <span id="cib-modal-close-icon" class="text-3xl material-symbols-rounded text-grey-800">close</span>
      </button>

      <div class="p-2">
        <span *ngIf="!isVoteTiedForCIBFinalisation" [ngStyle]="{'color': defaultOption.color}"
          class="material-symbols-rounded text-5xl" id="icon-{{ defaultOption.id }}">
          {{ defaultOption.icon }}
        </span>
        <p id="cib-modal-header" class="mt-2 mb-8 text-4xl text-left">
          Finalise Ballot
          <span *ngIf="!isVoteTiedForCIBFinalisation" class="text-4xl">
            - {{defaultOption.text}}
          </span>
        </p>
         <div *ngIf="isVoteTiedForCIBFinalisation" id="cib-radio-group" class="flex items-center justify-between my-4">
            <label class="flex items-center space-x-2 w-1/2" id="label-{{ agree.id }}">
              <input type="radio" id="radio-button-{{ agree.id }}" formControlName="ballotResponse" name="ballotResponse" [value]="agree.name" class="w-6 h-6 accent-black focus:ring-black"
                checked>
              <span [ngStyle]="{'color': agree.color}" class="material-symbols-rounded" id="icon-{{ agree.id }}">
                {{ agree.icon }}
              </span>
              <span class="text-2xl font-normal" id="text-{{ agree.id }}">
                {{ agree.text }}
              </span>
            </label>
            <label class="flex items-center space-x-2 w-1/2" id="label-{{ disagree.id }}">
              <input type="radio" formControlName="ballotResponse" name="ballotResponse" [value]="disagree.name" class="w-6 h-6 accent-black focus:ring-black" id="radio-button-{{ disagree.id }}">
              <span [ngStyle]="{'color': disagree.color}" class="material-symbols-rounded" id="icon-{{ disagree.id }}">
                {{ disagree.icon }}
              </span>
              <span class="text-2xl font-normal" id="text-{{ disagree.id }}">
                {{ disagree.text }}
              </span>
            </label>
          </div>


        <div id="cib-modal-footer" class="flex justify-between mt-4">
          <button id="cib-modal-cancel-button" (click)="cancel()"
            class="border border-gray-300 rounded-lg px-4 py-4 w-[calc(50%-0.5rem)] mr-2 hover:bg-gray-100 text-xl">
            Cancel
          </button>
          <button id="cib-modal-confirm-button" (click)="confirm()"
            class="btn btn-primary rounded-lg px-4 py-4 w-[calc(50%-0.5rem)] ml-2 text-xl">
            Finalise
          </button>
        </div>
      </div>

    </div>
  </div>
</form>
